import { getYoutubeId } from './getYoutubeId';
import {
  componentTypeEnums,
  getImageUrlFromCompressedImages,
  getMaxImgSizeForComponent,
} from './compressedImagesHelpers';

export function getImageThumbnailUrl(itemImage, shouldReturnThumbnailImage = true) {
  if (itemImage?.media_type === 2)
    return `https://img.youtube.com/vi/${getYoutubeId(
      itemImage?.thumbnail_url
    )}/hqdefault.jpg`;
  return shouldReturnThumbnailImage
    ? itemImage?.thumbnail_url
    : getImageUrlFromCompressedImages(
        itemImage?.compressed_images,
        itemImage?.thumbnail_url || itemImage?.image_url,
        {
          maxImgSize: getMaxImgSizeForComponent(componentTypeEnums.ITEM_THUMBNAIL),
        }
      );
}
